var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconButtonBold = function SvgIconButtonBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M12 17q2.075 0 3.537-1.463Q17 14.075 17 12q0-2.075-1.463-3.537Q14.075 7 12 7 9.925 7 8.463 8.463 7 9.926 7 12q0 2.075 1.463 3.537Q9.926 17 12 17m0 5.48q-2.188 0-4.098-.823A10.6 10.6 0 0 1 4.58 19.42a10.6 10.6 0 0 1-2.236-3.322Q1.52 14.188 1.52 12t.824-4.098A10.6 10.6 0 0 1 4.58 4.58a10.6 10.6 0 0 1 3.322-2.236Q9.812 1.52 12 1.52t4.098.824T19.42 4.58a10.6 10.6 0 0 1 2.236 3.322q.825 1.91.825 4.098t-.825 4.098a10.6 10.6 0 0 1-2.236 3.322 10.6 10.6 0 0 1-3.322 2.236q-1.91.825-4.098.825m0-2.65q3.294 0 5.562-2.268T19.83 12t-2.268-5.562T12 4.17 6.438 6.438 4.17 12t2.268 5.562T12 19.83"
  })));
};
export default SvgIconButtonBold;